export function MoreVertical(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="6"
        height="22"
        viewBox="0 0 6 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 3C6 4.65685 4.65685 6 3 6C1.34315 6 0 4.65685 0 3C0 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3Z"
          fill="currentColor"
        />
        <path
          d="M6 11C6 12.6569 4.65685 14 3 14C1.34315 14 0 12.6569 0 11C0 9.34315 1.34315 8 3 8C4.65685 8 6 9.34315 6 11Z"
          fill="currentColor"
        />
        <path
          d="M3 22C4.65685 22 6 20.6569 6 19C6 17.3431 4.65685 16 3 16C1.34315 16 0 17.3431 0 19C0 20.6569 1.34315 22 3 22Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
